import './notFoundPage.scss';

import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';
import { Button } from '../../components/Button/Button';
import useRouteStore from '../../store/routeStore/useRouteStore';
import useThemeStore from '../../store/themeStore/useThemeStore';
import { locator } from '../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const { assignLocation } = useRouteStore();

  const { t } = useTranslation();

  const redirectToDashboard = (): void => {
    assignLocation('/dashboard/garage');
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="page not-found-page">
        <main data-testid={locator.pages.notFound.main.root}>
          <span style={{ marginBottom: '1rem' }}>
            <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
          </span>

          <span style={{ marginBottom: '3rem' }}>
            <h1 data-testid={locator.pages.notFound.main.h1}>
              {t('NotFoundPage.title')}
            </h1>
            <h2 data-testid={locator.pages.notFound.main.h2}>
              {t('NotFoundPage.subtitle')}
            </h2>
          </span>

          <span>
            <Button
              data-testid={locator.pages.notFound.main.returnHomeButton}
              onClick={redirectToDashboard}
            >
              {t('NotFoundPage.returnHome')}
            </Button>
          </span>
        </main>
      </div>
    </ThemeProvider>
  );
}

Component.displayName = 'NotFoundPage';
